(function () {
  'use strict';


  angular
    .module('crewing')
    .controller('SBYCallOutCtrl', SBYCallOutCtrl);

  function SBYCallOutCtrl($uibModalInstance, modalParams,CrewingHelper) {
    var vm = this;

    vm.model = {
      title: modalParams.title,
      date:modalParams.date,
      time:modalParams.time,
      dateTime:'',
      error:''
    };

    vm.onCloseClick = function () {
      $uibModalInstance.close(modalParams.close);
    };

    vm.onYesClick = function(){
      if(!vm.model.date||!vm.model.time){
        vm.model.error=modalParams.error;
        return;
      }
      vm.model.dateTime=vm.model.date+' '+vm.model.time;
      CrewingHelper.setSbyCallOutDateTime(vm.model.dateTime);
      $uibModalInstance.close('YES');
    };

    vm.onNoClick = function(){
      $uibModalInstance.close();
    };
  }
}());
